import styled from "styled-components";
import { Table } from "antd";


const StyledComponentWrapper = styled.div`
background-color: #ffffff;
width: 100%;
max-width: 1480px;
height: 100%;
min-height: 0;
padding: 24px 28px;
display: flex;
flex-direction: column;
overflow: hidden;
box-sizing: border-box;

> .ant-spin-nested-loading,
> .ant-spin-nested-loading > .ant-spin-container {
  height: 100%;
  min-height: 0;
}

> .ant-spin-nested-loading > .ant-spin-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media (max-width:1800px){
  max-width: 1300px;
}

@media (max-width:1550px){
  max-width: 1080px;
}
@media (max-width:1300px){
  max-width: 950px;
}

@media (max-width: 1199px) {
  max-width: 780px;
}
@media (max-width: 788px), (max-width: 922px) {
  max-width: 712px;
}
@media (max-width: 720px) {
  max-width: 372px;
}
`;

const StyledTable = styled(Table)`
  > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table
    > .ant-table-container
    > .ant-table-content
    > table
    > .ant-table-tbody
    > tr.ant-table-row:hover
    > td {
    cursor: pointer;
  }
`;

const StyledDiv = styled.div`
  width: inherit;
  white-space: nowrap;
  text-overflow: ellipsis;
`;


const SearchFilterWrapper = styled.div`
  display: flex;
`;

const TableRow = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;

  > .ant-col {
    height: 100%;
    min-height: 0;
  }
`;

export { SearchFilterWrapper, StyledDiv, TableRow, StyledTable, StyledComponentWrapper };
